import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { nasluchujWyjsc, odslona } from '../lib/pomiar'

/**
 * Niewidoczny komponent pomiaru: odsłona przy każdej zmianie ścieżki
 * i jeden nasłuch kliknięć w linki zewnętrzne. Szczegóły i zasady w `lib/pomiar.js`.
 * Musi siedzieć wewnątrz `Router`, bo korzysta z `useLocation`.
 */
const PomiarOdslon = () => {
  const { pathname } = useLocation()

  useEffect(() => nasluchujWyjsc(), [])

  useEffect(() => {
    odslona(pathname)
  }, [pathname])

  return null
}

export default PomiarOdslon
